
export default {
  name: 'Testimonial',

  props: {
    testimonial: {
      type: Object,
      required: true,
    },
  },
};
